import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';


class RoutesListSupervisor extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    $('.sidebar-nav ul .has-child .child-menu').hide();
    $('.sidebar-nav ul .has-child > a').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next('.child-menu').slideToggle(300);
    });
  }

  render() {
    return (
      <div className="sidebar-nav">
        <ul>
          <li className="close-sesion"><Link to={"/"}><span>Cerrar sesión</span></Link></li>
        </ul>
      </div>
    );
  }
}

export default RoutesListSupervisor;



// WEBPACK FOOTER //
// ./src/routers/routesListSupervisor.js